import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookie-consent-accepted:v2026-04-22';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(
    () => localStorage.getItem(STORAGE_KEY) === '1'
  );

  if (accepted) return null;

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setAccepted(true);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-lg mx-auto bg-surface border border-on-surface/20 rounded-2xl shadow-lg px-5 py-4 flex items-center gap-4">
        <p className="text-on-surface text-sm flex-1">
          {t('legal.cookieMessage')}{' '}
          <Link to="/privacy" className="text-primary font-medium underline">
            {t('legal.privacy')}
          </Link>
        </p>
        <button
          type="button"
          onClick={handleAccept}
          className="bg-primary text-on-primary rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap"
        >
          {t('legal.cookieAccept')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
